import { useQuery, UseQueryResult } from '@tanstack/react-query';
import ReviewApiV2 from '../../../../../../lib/api/cs/review/ReviewApiV2';
import { REVIEW } from '../../../../../../constants/queryKeys';
import { ReviewFindOneResponseBodyDto } from '../../types/ReviewDetailTypes';
import { QueryOptions } from '../../../../../../types/query/useQuery';

type UseRelatedTagListQuery<SelectResultType> = {
  id: number;
  options?: QueryOptions<ReviewFindOneResponseBodyDto, unknown, SelectResultType>;
};

export const useFetchReviewQuery = <SelectResultType>(
  payload: UseRelatedTagListQuery<SelectResultType>,
): UseQueryResult<SelectResultType, unknown> => {
  const { id, options } = payload;
  return useQuery<ReviewFindOneResponseBodyDto, unknown, SelectResultType>(
    [...REVIEW.DETAIL, id],
    () => ReviewApiV2.getCsReviewDetail(id),
    {
      ...options,
      enabled: !!id,
    },
  );
};
